import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import OaDivider from '@orientaction/commons/OaDivider';
import { AdminTestContext } from '@orientaction/Context';
import { Fragment, useContext } from 'react';
import Item from './Item';
import style from './style';
import YoutubeIframe from '../../../../../../../VideoYoutubeEmbed';
import VariablesSection from '../../../VariablesSection';
import QuestionSection from '../../../QuestionsSection';

const CardContent = ({ responses, index}: any) => {
  const classes = style();
  const { test } = useContext<any>(AdminTestContext);

  return (
    <Card className={classes.cardContainer} variant="elevation" elevation={0}>
      <Grid container={true} className={classes.containerSection}>
        <VariablesSection idAglomeration={index} />
        <div className={classes.separator} />
        <QuestionSection idAglomeration={index} />
      </Grid>
    </Card>
  );
};

export default CardContent;
